import React, { useEffect, useState } from "react";

function ProductRangeLayout({
	sectionTitle,
	sectionSubtitle,
	sectionBody,
	products,
}) {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const handleScroll = () => setIsVisible(window.scrollY > 300);
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const paragraphs = Array.isArray(sectionBody)
		? sectionBody
		: [sectionBody];

	return (
		<div>
			<div className="max-w-4xl">
				<h2 className="text-2xl font-bold uppercase tracking-wide text-gray-900 md:text-[32px] md:leading-snug">
					{sectionTitle}
				</h2>
				{sectionSubtitle && (
					<h3 className="mt-3 text-lg font-medium text-primary md:text-xl">
						{sectionSubtitle}
					</h3>
				)}
				<div className="mt-4 space-y-3 text-[15px] leading-relaxed text-gray-700">
					{paragraphs.map((paragraph, index) => (
						<p key={index}>{paragraph}</p>
					))}
				</div>
			</div>

			<div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
				{products.map((product, index) => (
					<article
						key={index}
						className="flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow duration-300 hover:shadow-md"
					>
						<img
							src={product.image}
							alt={product.product_name}
							className="h-52 w-full object-cover"
						/>
						<div className="flex-1 px-5 py-4">
							<h4 className="text-base font-bold uppercase tracking-wide text-gray-900">
								{product.product_name}
							</h4>
							{product.description && (
								<p className="mt-1.5 text-sm leading-relaxed text-gray-500">
									{product.description}
								</p>
							)}
							{product.descriptions && (
								<ul className="mt-2 list-disc space-y-1 pl-4 text-sm leading-relaxed text-gray-500">
									{product.descriptions.map(
										(description, descIndex) => (
											<li key={descIndex}>
												{description}
											</li>
										)
									)}
								</ul>
							)}
						</div>
					</article>
				))}
			</div>

			{isVisible && (
				<button
					onClick={() =>
						window.scrollTo({ top: 0, behavior: "smooth" })
					}
					className="fixed bottom-5 right-5 rounded-md bg-primary px-3 py-2 font-overpass text-sm text-white shadow-md"
				>
					<i className="fas fa-arrow-up"></i> Scroll to Top
				</button>
			)}
		</div>
	);
}

export default ProductRangeLayout;
